<template>
    <div>
        <ul>
            <li v-if="baseData.poster">
                <div>演出海报:</div>
                <el-image :src="baseData.poster" :preview-src-list="srcList" fit="cover">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </li>
            <li v-if="baseData.showTypeTagName">
                <div>活动类型:</div>
                {{ baseData.showTypeTagName }}
            </li>
            <li v-if="baseData.type">
                <div>演出类型:</div>
                {{ activityMap.get(baseData.type) }}
            </li>
            <li v-if="baseData.siteTypeTagName">
                <div>场地类型:</div>
                {{ baseData.siteTypeTagName }}
            </li>
            <li v-if="baseData.title">
                <div>演出名称:</div>
                {{ baseData.title }}
            </li>
            <li v-if="baseData.siteVO && baseData.siteVO.name">
                <div>演出场地:</div>
                {{ baseData.siteVO.name }}
            </li>
			
            <li v-if="customSite">
                <div>演出场地:</div>
                <div v-if="current">
                    <el-button type="text" size="small" @click="siteBind()" v-if="status === 1">{{ siteValue && siteValue.name || customSite }}</el-button>
                    <template v-else>
                        {{ siteValue && siteValue.name || customSite }}
                    </template>
                    <span class="color-danger" v-if="!siteValue && status === 1">（此为用户自定义场地，点击演出场地进行处理）</span>
                </div>
                <template v-else>{{customSite}}</template>
            </li>
            <li v-if="baseData.sponsors && baseData.sponsors.length > 0">
                <div>演出主办:</div>
                {{ baseData.sponsors.map(item => item.name).toString() }}
            </li>
			<li v-if="baseData.undertaker && baseData.undertaker.length > 0">
			    <div>演出承办:</div>
			    {{ baseData.undertaker.map(item => item.name).toString() }}
			</li>
            <li v-if="baseData.contactsName">
                <div>演出联系人姓名:</div>
                {{ baseData.contactsName }}
            </li>
            <li v-if="baseData.contactsTel">
                <div>演出联系人手机:</div>
                {{ baseData.contactsTel }}
            </li>
            <li v-if="baseData.contactsMail">
                <div>演出联系人邮箱:</div>
                {{ baseData.contactsMail }}
            </li>
            <li v-if="baseData.sellIdentity">
                <div>售票模式:</div>
                {{sellIdentityMap.get(baseData.sellIdentity)}}
            </li>
			
            <li v-if="baseData.approvals">
                <div>演出批文:</div>
                <div>
					<!-- <template v-if="$utils.getFileType(baseData.approvals) == 'pdf'" >   
						<span class="pdf-box" @click="previewVisible = true"><pdf :src="baseData.approvals"></pdf></span>
					</template> -->
					<span v-if="approvals1" class="fl">
						<template v-if="$utils.getFileType(approvals1) == 'pdf'" >
							<span class="pdf-box" @click="previewVisible = true"><pdf :src="approvals1"></pdf></span>
						</template>
						<el-image :src='approvals1' :preview-src-list="approvalSrcList" fit="cover" v-else>
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</span>
					<span v-if="approvals2">
						<template v-if="$utils.getFileType(approvals2) == 'pdf'" >
							<span class="pdf-box" @click="previewVisible2 = true"><pdf :src="approvals2"></pdf></span>
						</template>
						<el-image :src='approvals2' :preview-src-list="approvalSrcList2" fit="cover" v-else>
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image><br>
					</span>
					<template v-if="baseData.hostList">						
						<span v-for="item in baseData.hostList" :key="item.id" class="MT10" style="width: 95%;">
							{{item.userName}} 
							<span v-if="item.claimType == 1 && item.headName"> (负责人姓名:{{item.headName}})</span>
							<span v-if="item.claimType == 2 && item.companyName"> (企业名称:{{item.companyName}})</span>
							<small v-if="item.status != 2" class="color-danger">(还未通过认证)</small>
						</span><br>
						<small class="color-danger MT5">(请注意核实批文中的举办单位跟演出主办对应的企业名称是否一致)</small>
					</template>
				</div>				
            </li>
			<li v-if="baseData.approvalsAgentCompany">
			    <div>演出报批公司:</div>
			    {{ baseData.approvalsAgentCompany }}
			</li>
			<!-- <li v-if="baseData.hostList">				
				<div></div>
				<div v-for="item in baseData.hostList" :key="item.id">
					{{item.userName}} 
					<span v-if="item.claimType == 1 && item.headName"> 负责人姓名:{{item.headName}}</span>
					<span v-if="item.claimType == 2 && item.companyName"> 企业名称:{{item.companyName}}</span>
					<small v-if="item.status != 2" class="color-danger">(还未通过认证)</small>
				</div>
							
			</li> -->
            <li v-if="baseData.approvalsSn">
                <div>批文编号:</div>
                {{ baseData.approvalsSn }}
            </li>
            <li v-if="baseData.approvalsPassTime">
                <div>报批通过日期:</div>
                {{ baseData.approvalsPassTime }}
            </li>
            <li v-if="baseData.approvalsUserNum">
                <div>报批人数:</div>
                {{ baseData.approvalsUserNum }}
            </li>
            <li v-if="baseData.serviceTemplateId">
                <div>购票须知:</div>
                {{ serviceTemplateName }}
            </li>
			<li v-if="baseData.recommendReason">
			    <div>推荐理由:</div>
			    {{ baseData.recommendReason }}
			</li>
            <li v-if="baseData.document">
                <div>演出简介:</div>
                <el-link type="text" @click="detailDialogVisible = true">点击查看详情</el-link>
            </li>
        </ul>
        <el-dialog
            title="修改详情"
            :visible.sync="detailDialogVisible"
            width="80%">
            <htmlDiff :oldContent="oldContent" :newContent="newContent"></htmlDiff>
        </el-dialog>   

        <el-dialog :visible.sync="previewVisible" title="高清预览" center append-to-body>
            <div class="preview-box">
				
                <template v-if="$utils.getFileType(approvals1) == 'pdf'">
                    <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>
                </template>
                <img v-else :src="approvals1">
            </div>
        </el-dialog>
		<el-dialog :visible.sync="previewVisible2" title="高清预览" center append-to-body>
		    <div class="preview-box">
		        <template v-if="$utils.getFileType(approvals2) == 'pdf'">
		            <pdf ref="pdf" v-for="i in numPages2" :key="i" :src="pdfUrl" :page="i"></pdf>
		        </template>
		        <img v-else :src="approvals2">
		    </div>
		</el-dialog>

    </div>    
</template>

<script>
import {nameMap, sellIdentity} from './mixins';
import htmlDiff from './htmlDiff'
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import {fetchServiceTemplateType} from  '@/assets/js/commonApi'

export default {
    data(){
        return {
            detailDialogVisible: false,
            numPages: null, // pdf 总页数
			numPages2: null, // pdf 总页数
            pdfUrl: '',
            previewVisible: false,
			previewVisible2: false,
            templateList: [],  
            serviceTemplateName: "",
			approvals1:'',
			approvals2:'',
			serviceTemplateType:[],
        }
    },
    components: {htmlDiff, pdf},
    mixins: [nameMap, sellIdentity],
    props: {
        baseData: {
            type: Object,
            default: ()=> {}
        },
        newContent: {
            type: String,
            default: ''
        },
        oldContent: {
            type: String,
            default: ''
        },
        siteValue: {
            type: Object,
            default: () => null
        },
        current: {
            type: Boolean,
            default: false
        },
        status: {
            type: Number,
            default: 1
        },
		activityId:{
			type:[Number,String],
			default: ''
		}
    },
    computed: {
        customSite() {
            if(!this.baseData.customSite || this.baseData.customSite == 'null') return false;
            return JSON.parse(this.baseData.customSite).name;
        },
        srcList(){
            return [this.baseData.posterOriginal]
        },
        approvalSrcList(){
            return [this.approvals1]
        },
		approvalSrcList2(){
		    return [this.approvals2]
		}
    },
    created(){
		this.serviceTemplateType =  fetchServiceTemplateType();
		if( this.baseData.approvals ){
			var approvals = this.baseData.approvals.split(',')					
			if( approvals.length > 0 && approvals[0]){
				this.approvals1 = approvals[0]
			}
			if( approvals.length > 0 && approvals[1]){
				this.approvals2 = approvals[1]
			}
		}
		
    },
    mounted(){
        if(this.$utils.getFileType(this.approvals1) == 'pdf'){
            this.getNumPages(this.approvals1);
        }
		if(this.$utils.getFileType(this.approvals2) == 'pdf'){
		    this.getNumPages2(this.approvals2);
		}
		if(this.activityId){
			this.getTemplate();
		}
    },
    methods:{
        //获取服务模板
        getTemplate(){
            this.templateList = [];
            this.$request({
                url: "/activity/getTemplate",
                method: "post",
				params:{
					activityId:this.activityId
				}
            }).then(res => {
                const { state, result } = res.data;
                if(state == 1 && result){
					var _result = result					
					for (let key1 in _result) {
						
						for (let key2 in _result[key1]) {
							
							this.templateList = this.templateList.concat(_result[key1][key2]);
							
						}
					}
					const _ids = this.baseData.serviceTemplateId ? this.baseData.serviceTemplateId.split(",") : [];
				   let _names = [];
				   _ids.map( v => {
					   const _item = this.templateList.find( item => item.id == v )
					   if( _item ){
						   _names.push( _item.title );
					   }
				   })
				   this.serviceTemplateName = _names.toString();
				  

                }
            })
        },
        // 计算pdf页码总数
        getNumPages(_url) {
            const url = _url || this.approvals1;
            this.pdfUrl = pdf.createLoadingTask({ url: url, CMapReaderFactory });
            let loadingTask = pdf.createLoadingTask(url)
            loadingTask.promise.then(pdf => {
                this.numPages = pdf.numPages
            }).catch(err => {
                console.error('pdf 加载失败', err);
            })
			
        },
		// 计算pdf页码总数
		getNumPages2(_url) {
		    const url = _url || this.approvals2;
		    this.pdfUrl = pdf.createLoadingTask({ url: url, CMapReaderFactory });
		    let loadingTask = pdf.createLoadingTask(url)
		    loadingTask.promise.then(pdf => {
		        this.numPages2 = pdf.numPages
		    }).catch(err => {
		        console.error('pdf 加载失败', err);
		    })
			
		},

        siteBind(){
            this.$emit('siteBind');
        }
    }
}
</script>

<style lang="scss" scoped>
li{
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    .el-button{
        padding: 0;
    }
    span{
        display: inline-block;
    }
    div:first-child{
        margin-right: 10px;
        width: 200px;
        min-width: 200px;
        text-align: right;
        color: $--color-info;
    }
	
    ::v-deep .el-image,
    .pdf-box{
        width: 200px;
        height: 200px;
        overflow: hidden;
    }
	
    .pdf-box{
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
    }
    &:nth-last-child(1){
        margin: 0
    }
}
.MT5{
	margin-top: 5px;
	display: inline-block;
}
</style>